import { gql, useQuery } from "@apollo/client";
import { Suspense, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { PATHS } from "./paths";
import { CSIsLoggedIn as IS_LOGGED_IN } from "../customGraphql/queries";
import { ConversationLayout } from "../components/ConversationLayout";
import OnboardingLayout from "../components/OnboardingLayout";
import ConversationDetail from "../pages/Conversations/ConversationDetail";
import Interests from "../pages/Interests";
import OnboardingInterests from "../pages/OnboardingInterests";
import OnboardingLocations from "../pages/OnboardingLocations";
import OnboardingPlans from "../pages/OnboardingPlans";
import OnboardingStripeCheckoutConfirm from "../pages/OnboardingStripeCheckoutConfirm";
import Plans from "../pages/Plans";
import ProductCreateUpdate from "../pages/ProductCreateUpdate";
import Products from "../pages/Products";
import ProductView from "../pages/ProductView";
import StripeCheckoutConfirm from "../pages/StripeCheckoutConfirm";
import Swipes from "../pages/Swipes";
import TeamCreateUpdate from "../pages/TeamCreateUpdate";
import OnboardingUser from "../pages/OnboardingUser";
import TeamUserCreateUpdate from "../pages/TeamUserCreateUpdate";
import UserUpdate from "../pages/UserUpdate";
import UnAuthLayout from "../components/UnAuthLayout";
import ChangePassword from "../pages/ChangePassword";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/NotFound";
import ResetPassword from "../pages/ResetPassword";
import Settings from "../pages/Settings";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import User from "../pages/User";
import Team from "../pages/Team";

export const NavRoutes = () => {
  const { data: loggedInData } = useQuery(gql(IS_LOGGED_IN));
  const isLoggedIn = useMemo(
    () => loggedInData?.isLoggedIn || false,
    [loggedInData]
  );

  return (
    <Routes>
      <Route element={<UnAuthLayout />}>
        {!isLoggedIn && <Route path={PATHS.root} element={<SignIn />} />}
        <Route path={PATHS.resetPassword} element={<ResetPassword />} />
        <Route path={"/signin"} element={<SignIn />} />
        <Route path={PATHS.signIn} element={<SignIn />} />
        <Route path={PATHS.signUp} element={<SignUp />} />
      </Route>

      <Route element={<OnboardingLayout />}>
        <Route path={PATHS.onboardingUser} element={<OnboardingUser />} />
        <Route
          path={PATHS.onboardingInterests}
          element={<OnboardingInterests />}
        />
        <Route
          path={PATHS.onboardingLocations}
          element={<OnboardingLocations />}
        />
        <Route path={PATHS.onboardingPlans} element={<OnboardingPlans />} />
        <Route
          path={PATHS.onboardingCheckoutConfirm}
          element={<OnboardingStripeCheckoutConfirm />}
        />
      </Route>

      <Route element={<ConversationLayout />}>
        {isLoggedIn && <Route path={PATHS.root} element={<Dashboard />} />}
        <Route path={PATHS.changePassword} element={<ChangePassword />} />
        <Route path={PATHS.dashboard} element={<Dashboard />} />
        <Route path={PATHS.settings} element={<Settings />} />
        <Route path="tags">
          <Route
            index
            element={
              <Suspense fallback={<></>}>
                <Interests />
              </Suspense>
            }
          />
        </Route>
        <Route path="user">
          <Route index element={<User />} />
          {/*<Route*/}
          {/*  path="create"*/}
          {/*  element={*/}
          {/*    <Suspense fallback={<></>}>*/}
          {/*      <UserUpdate />*/}
          {/*    </Suspense>*/}
          {/*  }*/}
          {/*/>*/}
          <Route path="view" element={<User />} />
          <Route path="view/:userId" element={<User />} />
          <Route path="update/:userId" element={<UserUpdate />} />
        </Route>
        <Route path="conversations" element={<ConversationDetail />} />
        <Route
          path="conversations/:conversationId"
          element={<ConversationDetail />}
        />
        <Route path="products">
          <Route index element={<Products />} />
          <Route path=":userId" element={<Products />} />
          <Route path="create" element={<ProductCreateUpdate />} />
          <Route path="view/:productId" element={<ProductView />} />
          <Route path="update/:productId" element={<ProductCreateUpdate />} />
        </Route>
        <Route path="team">
          <Route path=":teamId" element={<Team />} />
          <Route path="create" element={<TeamCreateUpdate />} />
          <Route path="update/:teamId" element={<TeamCreateUpdate />} />
          <Route path=":teamId/users" element={<TeamUserCreateUpdate />} />
        </Route>
        <Route path="plans">
          <Route index element={<Plans />} />
        </Route>
        <Route path="swipes">
          <Route index element={<Swipes />} />
        </Route>
        <Route
          path={PATHS.checkoutConfirm}
          element={<StripeCheckoutConfirm />}
        />
      </Route>

      {/*<Route element={<AuthLayout />}>*/}
      {/*  <Route path={PATHS.changePassword} element={<ChangePassword />} />*/}
      {/*  <Route path={PATHS.dashboard} element={<Dashboard />} />*/}
      {/*  <Route path={PATHS.settings} element={<Settings />} />*/}
      {/*  <Route path="tags">*/}
      {/*    <Route*/}
      {/*      index*/}
      {/*      element={*/}
      {/*        <Suspense fallback={<></>}>*/}
      {/*          <Interests />*/}
      {/*        </Suspense>*/}
      {/*      }*/}
      {/*    />*/}
      {/*  </Route>*/}
      {/*  <Route path="user">*/}
      {/*    <Route index element={<User />} />*/}
      {/*    <Route*/}
      {/*      path="create"*/}
      {/*      element={*/}
      {/*        <Suspense fallback={<></>}>*/}
      {/*          <UserCreateUpdate />*/}
      {/*        </Suspense>*/}
      {/*      }*/}
      {/*    />*/}
      {/*    <Route path="view" element={<User />} />*/}
      {/*    <Route path="view/:userId" element={<User />} />*/}
      {/*    <Route path="update/:userId" element={<UserCreateUpdate />} />*/}
      {/*  </Route>*/}
      {/*  <Route path="conversations">*/}
      {/*    <Route index element={<Conversations />} />*/}
      {/*    <Route path=":conversationId" element={<Conversations />} />*/}
      {/*  </Route>*/}
      {/*  <Route path="products">*/}
      {/*    <Route index element={<Products />} />*/}
      {/*    <Route path=":userId" element={<Products />} />*/}
      {/*    <Route path="create" element={<ProductCreateUpdate />} />*/}
      {/*    <Route path="view/:productId" element={<ProductView />} />*/}
      {/*    <Route path="update/:productId" element={<ProductCreateUpdate />} />*/}
      {/*  </Route>*/}
      {/*  <Route path="team">*/}
      {/*    <Route path=":teamId" element={<Team />} />*/}
      {/*    <Route path="create" element={<TeamCreateUpdate />} />*/}
      {/*    <Route path="update/:teamId" element={<TeamCreateUpdate />} />*/}
      {/*    <Route path=":teamId/users" element={<TeamUserCreateUpdate />} />*/}
      {/*  </Route>*/}
      {/*  <Route path="plans">*/}
      {/*    <Route index element={<Plans />} />*/}
      {/*  </Route>*/}
      {/*  <Route path="swipes">*/}
      {/*    <Route index element={<Swipes />} />*/}
      {/*  </Route>*/}
      {/*  <Route*/}
      {/*    path={PATHS.checkoutConfirm}*/}
      {/*    element={<StripeCheckoutConfirm />}*/}
      {/*  />*/}
      {/*</Route>*/}

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
